<template>
	<v-text-field
		v-model.trim="model"
		:label="label"
		:outlined="outlined"
		:dense="dense"
		:clearable="clearable"
		:rules="rules"
		@keyup.ctrl.90="model='WAUZZZ4M0HD001505'"
		hide-details="auto"
	>
		<template v-slot:append-outer>
			<v-tooltip bottom v-if="identification">
      			<template v-slot:activator="{ on, attrs }">
					<v-icon v-bind="attrs" v-on="on" @click="onIdentification">mdi-car-search</v-icon>
				</template>
				<span>Ідентифікація</span>
			</v-tooltip>
		</template>
	</v-text-field>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin],
	props: {
		label:  			{ type: String, default: 'VIN-код'},
		identification:		{ type: Boolean, default: false }, // Ознака відображення кнопки для ідентифікації ТЗ 
	},
	computed: {

	},
	methods: {
		onKeyup() {
			this.model = 'WAUZZZ4M0HD001505'
		},

		onIdentification() {
			//console.log('VehicleNumber', 'onIdentification', 'model', this.model)
			this.$emit('identification', this.model)
		},
	},
}
</script>